import React from 'react';

import { Icon } from 'design-system-web';

import type {
  QuestionTypeDisplay,
  QuestionTypeIcon,
} from '../../model/questionTypeCatalog';

import styles from './QuestionTable.scss';

type Props = {
  viewModel: QuestionTypeDisplay;
};

const ICON_NAME_BY_QUESTION_TYPE_ICON: Record<QuestionTypeIcon, string> = {
  rating: 'star',
  choice: 'check-circle',
  checklist: 'tasks',
  text: 'align-left',
  numeric: 'hashtag',
  date: 'calendar-alt',
  list: 'list-ul',
  observation: 'eye',
  unknown: 'question-circle',
};

export function ResponseTypeCell({ viewModel }: Props) {
  return (
    <div role="cell" className={styles.responseType}>
      <Icon name={ICON_NAME_BY_QUESTION_TYPE_ICON[viewModel.icon]} />
      <span>{viewModel.displayName}</span>
    </div>
  );
}
